<template>
  <small class="align-middle font-weight-bold text-danger">*</small>
</template>